export var EventType;

(function (EventType) {
  EventType["Performance"] = "Performance";
  EventType["CustomEvent"] = "CustomEvent";
  EventType["Qos"] = "Qos";
  EventType["Warn"] = "Warn";
  EventType["Error"] = "Error";
})(EventType || (EventType = {}));
//# sourceMappingURL=EventType.js.map